import React, { useContext } from 'react';
import { Link } from "react-router-dom";
// import ExpandLess from '@material-ui/icons/ExpandLess';
// import ExpandMore from '@material-ui/icons/ExpandMore';
import HomeIcon from '@material-ui/icons/Home';
import ApartmentIcon from '@material-ui/icons/Apartment';
import PeopleIcon from '@material-ui/icons/People';
import {
  Typography,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  IconButton,
  Container,
//   List,
//   Collapse,
  makeStyles,
} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import classNames from 'classnames';
import { AppContext } from './AppContextProvider';
// import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import AssignmentIcon from '@material-ui/icons/Assignment';
// import AssessmentIcon from '@material-ui/icons/Assessment';
import DescriptionIcon from '@material-ui/icons/Description';
import DraftsIcon from '@material-ui/icons/Drafts';
import ReceiptIcon from '@material-ui/icons/Receipt';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      drawerClose: {
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9) + 1,
        },
      },
      toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
      },
      sectionDesktop: {
        display: 'flex',
        fontSize: 16,
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      },
      menuIcon: {
        minWidth: 32
      },
      subMenuTitle: {
        // paddingLeft: 32, 
        paddingTop: 0, 
        paddingBottom: 0
      },
      subMenuItem: {
        color: 'black',
        // paddingTop: 0, 
        // paddingBottom: 0
      },
      nested: {
        paddingLeft: 48, 
        // color: 'black',
        paddingTop: 0, 
        paddingBottom: 0,
      },
      link: {
        textDecoration: 'none !important', 
        color: 'black' 
      },
}));

export default function AppDrawer(props) {

    const classes = useStyles();
    const {state, handleDrawerClose} = useContext(AppContext);

    // const [openDrawer, setOpenDrawer] = React.useState({
    //     accounts: false,
    //     loans: false,
    //     tools: false,
    //     finance: false,
    //     masters: false,
    //     reports: false,
    // })

    // const handleClick = (type) => {
    //     // openDrawer[type] = !openDrawer[type];
    //     setOpenDrawer(openDrawer => ({...openDrawer, [type]: !openDrawer[type]}))
    // }

    return (
        <Drawer
            anchor="left"
            className={classNames(classes.drawer, {
                [classes.drawerOpen]: state.open,
                [classes.drawerClose]: !state.open,
            })}
            classes={{
                paper: classNames({
                    [classes.drawerOpen]: state.open,
                    [classes.drawerClose]: !state.open,
                }),
            }}
            open={state.open}
            onClose={handleDrawerClose}
        >
            <div>
                <div className={classes.toolbar}>
                    <div style={{ float: "left", width: "100%", marginLeft: 2 }}>
                        <img
                            src={process.env.PUBLIC_URL + "/images/icon.png"}
                            alt="icon"
                            height={40}
                        />
                    </div>
                    <IconButton onClick={handleDrawerClose}>
                        {/* <AccountCircleIcon className={classes.accountCircle}/> */}
                        {state.isAuthenticated && (
                            <section className={classes.sectionDesktop}>
                                {state.user.name}
                            </section>
                        )}
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <div style={{ height: "85vh", overflow: "auto" }}>
                    <Divider />
                    <Link
                        to="/"
                        style={{ textDecoration: "none", color: "black" }}
                        onClick={handleDrawerClose}
                    >
                        <ListItem button key="Dashboard">
                            <ListItemIcon className={classes.menuIcon}>
                                <HomeIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="subtitle2">Dashboard</Typography>}
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    <Link to="/properties" style={{ textDecoration: "none", color: "black" }} onClick={handleDrawerClose}>
                        <ListItem button key="Properties">
                            <ListItemIcon className={classes.menuIcon}>
                                <ApartmentIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2">
                                        Properties
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    <Link to="/tenants" style={{ textDecoration: "none", color: "black" }} onClick={handleDrawerClose}>
                        <ListItem button key="Tenants">
                            <ListItemIcon className={classes.menuIcon}>
                                <PeopleIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2">
                                        Tenants
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    <Link to="/agreements" style={{ textDecoration: "none", color: "black" }} onClick={handleDrawerClose}>
                        <ListItem button key="Agreements">
                            <ListItemIcon className={classes.menuIcon}>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2">
                                        Agreements
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    <Link to="/manage/draft/agreements" style={{ textDecoration: "none", color: "black" }} onClick={handleDrawerClose}>
                        <ListItem button key="Manage Draft Agreements">
                            <ListItemIcon className={classes.menuIcon}>
                                <DraftsIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2">
                                        Manage Draft Agreements
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    <Link to="/manage/questionnaire" style={{ textDecoration: "none", color: "black" }} onClick={handleDrawerClose}>
                        <ListItem button key="Manage Questionnaire">
                            <ListItemIcon className={classes.menuIcon}>
                                <DescriptionIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2">
                                        Manage Questionnaire
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    <Link to="/view/invoice" style={{ textDecoration: "none", color: "black" }} onClick={handleDrawerClose}>
                        <ListItem button key="Invoices">
                            <ListItemIcon className={classes.menuIcon}>
                                <InsertDriveFileIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2">
                                        Invoices
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                    {/* <div>
                            <List className={classes.subMenuTitle}>
                                <ListItem button onClick={(e) => handleClick("reports")}>
                                    <ListItemIcon className={classes.menuIcon}>
                                        <AssessmentIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <Typography
                                                variant="subtitle2"
                                                align="left"
                                                className="sub-menu"
                                            >
                                                Reports
                                            </Typography>
                                        }
                                    />
                                    {openDrawer["reports"] ? (
                                        <ExpandLess />
                                    ) : (
                                            <ExpandMore />
                                        )}
                                </ListItem>
                                <Collapse
                                    in={openDrawer["reports"]}
                                    timeout="auto"
                                    unmountOnExit
                                    className={classes.subMenuItem}
                                >
                                    <List
                                        component="div"
                                        disablePadding
                                        onClick={handleDrawerClose}
                                    >
                                        <Link to="/report/property/vacant" className={classes.link}>
                                            <ListItem button key="View Vacant Property" className={classes.nested}>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="subtitle2">View Vacant Property</Typography>
                                                    }
                                                />
                                            </ListItem>
                                        </Link>
                                        <Link to="/report/property/rental" className={classes.link}>
                                            <ListItem button key="Rental Income" className={classes.nested}>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="subtitle2">Rental Income</Typography>
                                                    }
                                                />
                                            </ListItem>
                                        </Link>
                                        <Link to="/report/rent/due" className={classes.link}>
                                            <ListItem button key="Rentals Due" className={classes.nested}>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="subtitle2">Rentals Due</Typography>
                                                    }
                                                />
                                            </ListItem>
                                        </Link>
                                    </List>
                                </Collapse>
                            </List>
                        </div>
                    */}
                    {/* <Divider /> */}
                    <Link to="/manage/invoice/config" style={{ textDecoration: "none", color: "black" }} onClick={handleDrawerClose}>
                        <ListItem button key="Invoice Configuration">
                            <ListItemIcon className={classes.menuIcon}>
                                <ReceiptIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2">
                                        Invoice Configuration
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Link>
                    <Divider />
                </div>
            </div>
            <div>
                <Container maxWidth="sm" style={{ position: "absolute", bottom: 0 }}>
                    <Typography variant="subtitle2" style={{ textAlign: "center", fontSize: 10 }}>
                        Version: {global.appVersion}
                        <React.Fragment>
                            <br />
                                Powered by Sysbrew
                        </React.Fragment>
                    </Typography>
                </Container>
            </div>
        </Drawer>
    );
}
